module.exports = __webpack_public_path__ + "img/EinJederDenktSichDasSeine.7113c7df.jpg";